"use strict";
var __extends = (this && this.__extends) || (function () {
    var extendStatics = function (d, b) {
        extendStatics = Object.setPrototypeOf ||
            ({ __proto__: [] } instanceof Array && function (d, b) { d.__proto__ = b; }) ||
            function (d, b) { for (var p in b) if (b.hasOwnProperty(p)) d[p] = b[p]; };
        return extendStatics(d, b);
    };
    return function (d, b) {
        extendStatics(d, b);
        function __() { this.constructor = d; }
        d.prototype = b === null ? Object.create(b) : (__.prototype = b.prototype, new __());
    };
})();
var __assign = (this && this.__assign) || function () {
    __assign = Object.assign || function(t) {
        for (var s, i = 1, n = arguments.length; i < n; i++) {
            s = arguments[i];
            for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p))
                t[p] = s[p];
        }
        return t;
    };
    return __assign.apply(this, arguments);
};
Object.defineProperty(exports, "__esModule", { value: true });
var React = require("react");
var PropTypes = require("prop-types");
var ReactDOM = require("react-dom");
var classnames_1 = require("../util/classnames");
var events = require("../util/dom-helpers/events");
var dom_helpers_1 = require("../util/dom-helpers");
var create_chained_function_1 = require("../util/create-chained-function");
var react_overlays_1 = require("../react-overlays");
var react_prop_types_1 = require("../react-prop-types");
var fade_1 = require("../fade");
var dialog_1 = require("./dialog");
var body_1 = require("./body");
var header_1 = require("./header");
var title_1 = require("./title");
var footer_1 = require("./footer");
var vdl_prefix_1 = require("../util/vdl-prefix");
var _1 = require("../util/_");
var Modal = /** @class */ (function (_super) {
    __extends(Modal, _super);
    function Modal(props) {
        var _this = _super.call(this, props) || this;
        _this.state = {
            modalStyles: {}
        };
        _this.handleEntering = function () {
            // FIXME: This should work even when animation is disabled.
            events.on(window, 'resize', _this.handleWindowResize);
            _this.updateStyle();
        };
        _this.handleExited = function () {
            // FIXME: This should work even when animation is disabled.
            events.off(window, 'resize', _this.handleWindowResize);
        };
        _this.handleWindowResize = function () {
            _this.updateStyle();
        };
        _this.handleDialogClick = function (e) {
            if (e.target !== e.currentTarget) {
                return;
            }
            if (_this.props.onHide) {
                _this.props.onHide();
            }
        };
        _this.updateStyle = function () {
            if (!dom_helpers_1.inDOM) {
                return;
            }
            var dialogNode = _this._modal.getDialogElement();
            var dialogHeight = dialogNode ? dialogNode.scrollHeight : 0;
            var document = dom_helpers_1.ownerDocument(dialogNode);
            var bodyIsOverflowing = react_overlays_1.isOverflowing(ReactDOM.findDOMNode(_this.props.container || document.body));
            var modalIsOverflowing = dialogHeight > document.documentElement.clientHeight;
            _this.setState({
                style: {
                    paddingRight: bodyIsOverflowing && !modalIsOverflowing ? dom_helpers_1.scrollbarSize() : undefined,
                    paddingLeft: !bodyIsOverflowing && modalIsOverflowing ? dom_helpers_1.scrollbarSize() : undefined
                }
            });
            if (_this._wrapper) {
                _this._wrapper.parentNode.className = vdl_prefix_1.vdlPrefix('modal-mount');
            }
        };
        _this.childContext = {
            '$vdl_onModalHide': props.onHide
        };
        return _this;
    }
    Modal.prototype.getChildContext = function () {
        return {
            '$vdl_onModalHide': this.props.onHide
        };
    };
    Modal.prototype.componentWillUnmount = function () {
        // Clean up the listener if we need to.
        this.handleExited();
    };
    Modal.prototype.render = function () {
        var _this = this;
        var _a = this.props, backdrop = _a.backdrop, animation = _a.animation, show = _a.show, Dialog = _a.dialogComponentClass, className = _a.className, style = _a.style, children = _a.children, // Just in case this get added to BaseModal propTypes.
        onEntering = _a.onEntering;
        var props = _1.omit(this.props, [
            'backdrop',
            'animation',
            'show',
            'dialogComponentClass',
            'className',
            'style',
            'children',
            'onEntering',
            'onExited'
        ]);
        var _b = _1.splitComponentProps(props, react_overlays_1.BaseModal), baseModalProps = _b[0], dialogProps = _b[1];
        var inClassName = (show && !animation) ? 'in' : undefined;
        return (React.createElement(react_overlays_1.BaseModal, __assign({}, baseModalProps, { ref: function (c) {
                _this._modal = c;
                _this._wrapper = (c ? c.getDialogElement() : undefined);
            }, show: show, onEntering: create_chained_function_1.default(onEntering, this.handleEntering), 
            // onExited={ createChainedFunction(onExited, this.handleExited) }
            backdrop: backdrop, backdropClassName: classnames_1.classNames(vdl_prefix_1.vdlPrefix('modal-backdrop'), inClassName), containerClassName: vdl_prefix_1.vdlPrefix('modal-open'), transition: animation ? fade_1.Fade : undefined, dialogTransitionTimeout: Modal.TRANSITION_DURATION, backdropTransitionTimeout: Modal.BACKDROP_TRANSITION_DURATION }),
            React.createElement(Dialog, __assign({}, dialogProps, { style: Object.assign({}, this.state.style, style), className: classnames_1.classNames(className, inClassName), onClick: backdrop === true ? this.handleDialogClick : undefined }), children)));
    };
    Modal.propTypes = Object.assign({}, react_overlays_1.BaseModal.propTypes, dialog_1.ModalDialog.propTypes, {
        backdrop: PropTypes.oneOf(['static', true, false]),
        keyboard: PropTypes.bool,
        animation: PropTypes.bool,
        dialogComponentClass: react_prop_types_1.elementType,
        autoFocus: PropTypes.bool,
        enforceFocus: PropTypes.bool,
        show: PropTypes.bool,
        onHide: PropTypes.func,
        onEnter: PropTypes.func,
        onEntering: PropTypes.func,
        onEntered: PropTypes.func,
        onExit: PropTypes.func,
        onExiting: PropTypes.func,
        onExited: PropTypes.func,
        /**
         * @private
         */
        container: react_overlays_1.BaseModal.propTypes.container,
        className: PropTypes.string,
        style: PropTypes.object
    });
    Modal.childContextTypes = {
        '$vdl_onModalHide': PropTypes.func
    };
    Modal.defaultProps = Object.assign({}, react_overlays_1.BaseModal.defaultProps, {
        animation: true,
        dialogComponentClass: dialog_1.ModalDialog
    });
    Modal.Body = body_1.ModalBody;
    Modal.Header = header_1.ModalHeader;
    Modal.Title = title_1.ModalTitle;
    Modal.Footer = footer_1.ModalFooter;
    Modal.Dialog = dialog_1.ModalDialog;
    Modal.TRANSITION_DURATION = 300;
    Modal.BACKDROP_TRANSITION_DURATION = 150;
    return Modal;
}(React.Component));
exports.Modal = Modal;
